import { render } from "./HorseColorListView.vue?vue&type=template&id=73260b90&scoped=true"
import script from "./HorseColorListView.vue?vue&type=script&lang=js"
export * from "./HorseColorListView.vue?vue&type=script&lang=js"

import "./HorseColorListView.vue?vue&type=style&index=0&id=73260b90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73260b90"]])

export default __exports__